export default defineNuxtRouteMiddleware(async (to, from) => {
    if (to.meta?.auth === false) {
        return
    }
    const { fetchSession } = useAuth()
    if (import.meta.client) {
        await fetchSession()
    }
})